Drupal.geolocation.google.addLoadedCallback(function() {
  $('.map').once('sw-map').each(function() {
    var m = new SwMap($(this));
  });
});

var SwMap = function( $wrap ) {
	var _this = this;

	this.$wrap = $wrap;

	this.$wrap.data('sw-map', this);

	this.init();
}

SwMap.prototype.init = function() {
	var _this = this;

	this.map = new google.maps.Map( this.$wrap[0], {
		zoom: 10,
		disableDefaultUI: true,
		zoomControl: true,
		fullscreenControl: true,
		//draggable: false,
		//scrollwheel: false,
		//clickableIcons: false,
		styles: [
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#444444"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [
					{
						"color": "#fcfcfc"
					}
				]
			},
			{
				"featureType": "landscape.natural",
				"elementType": "all",
				"stylers": [
					{
						"color": "#f3f3f3"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [
					{
						"saturation": -100
					},
					{
						"lightness": 45
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{
						"color": "#00A6D5"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#00A6D5"
					}
				]
			}
		],
	});

	this.locations = [];
	this.markers = [];
	var location = this.$wrap.data('location');
	if ( location ) {
		this.locations.push(location);
	}

	if ( this.locations.length === 0 ) {
		var pos = new google.maps.LatLng ( 40.084380, -98.171144 );
		this.map.setCenter ( pos );
	} else {
		var bounds = new google.maps.LatLngBounds();
		//var icon = Drupal.settings.basePath + 'sites/all/themes/mytheme/images/marker.png';
		for ( var i = 0; i < this.locations.length; i ++ ) {
			var location = this.locations[i];
			if ( location ) {
				var pos = new google.maps.LatLng ( location[0], location[1] );
				bounds.extend ( pos );
				var icon = {
					path: "M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z",
					fillColor: '#6a9eb2',
					strokeColor: '#002273',
					fillOpacity: 1,
					anchor: new google.maps.Point(12,24),
					strokeWeight: 1,
					scale: 2,
				}
				var marker = new google.maps.Marker ( {
					map: this.map,
					//animation: google.maps.Animation.DROP,
					position: pos,
					icon: icon,
					title: this.$wrap.data('location-title'),
					point_delta: i,
					zIndex: 10
				} );
				google.maps.event.addListener( marker, 'click', function() {
					//var point_delta = this.point_delta;
					//_this.info_open ( point_delta );
          var link = _this.$wrap.data('marker-link');
          if ( link ) {
            //window.location.href = link;
            window.open(link, '_blank');
          }
				});
				this.markers[i] = marker;
			}
		}
		google.maps.event.trigger ( this.map, 'resize' );
		if ( this.markers.length === 1 ) {
			this.map.setCenter(pos);
			this.map.setZoom(14);
		} else {
			this.map.fitBounds(bounds);
		}
	}
}
